import { MultilingualLanguages } from '@asgard/api-common';
import JoinUsComponent from 'components/marketingSite/joinUs/JoinUsComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WebOfferSummary } from 'model/model.web-offer-summary';
import { GetStaticProps } from 'next';
import { WithTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ServiceWebOffer } from 'services/service.web-offer';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type JoinUsPageProps = {
  offers: WebOfferSummary[];
  baseUrl?: string;
};

const JoinUsPage: React.FC<JoinUsPageProps & WithTranslation> = (props) => {
  const { t } = useI18n('join-us');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('pageTitle')}
        desc={t('join.desc')}
        url={APP_URLS.joinUs}
        imgUrl={`${props.baseUrl}${getPublicPath(
          '/images/cards/card_joinus.png'
        )}`}
      />

      <JoinUsComponent {...props} />
    </>
  );
};

export default JoinUsPage;

export const getStaticProps: GetStaticProps<JoinUsPageProps> = async ({
  locale
}) => {
  const offers = await ServiceWebOffer.getAllSummary(
    {
      text: 'Manfred',
      onlyActive: true
    },
    locale?.toUpperCase() as MultilingualLanguages,
    'public-endpoint'
  );

  return {
    props: {
      offers: JSON.parse(JSON.stringify(offers)),
      ...(await serverSideTranslations(locale || '', [
        'common',
        'join-us',
        'job-offer-list',
        'job-offer',
        'topbar',
        'footer'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
